import React from 'react';
import { useSWRConfig } from 'swr';
import { authenticatedFetcher } from '@/lib/swr';
import { PP_BASE_URL } from '@/lib/env';

export function useStudentSync() {
  const { mutate } = useSWRConfig();
  const [isSyncing, setIsSyncing] = React.useState(false);
  const [syncError, setSyncError] = React.useState<string | null>(null);

  const syncStudents = React.useCallback(async () => {
    setIsSyncing(true);
    setSyncError(null);

    try {
      const baseUrl = PP_BASE_URL!.replace(/\/$/, '');
      await authenticatedFetcher(`${baseUrl}/students/sync`, { method: 'POST' });

      // Automatically revalidate all student profile and sync caches
      await mutate((key) => typeof key === 'string' && key.startsWith(`${baseUrl}/students`));
    } catch (err: any) {
      const errorMsg = err?.message || err?.error || 'An error occurred while syncing student profiles';
      setSyncError(errorMsg);
      throw err;
    } finally {
      setIsSyncing(false);
    }
  }, [mutate]);

  return {
    syncStudents,
    isSyncing,
    syncError,
    setSyncError,
  };
}


